import { createModel } from "@rematch/core";
import { RootModel } from "../rootModel";
import { IElectronicDocuments } from "shared/models";
import { apiInstance } from "shared/api/config/apiInstance";
import { GET_CONTRACTS_NUMBER, GET_ELECTRONIC_DOCS } from "shared/api";
import { downloadDocument } from "shared/utils/helpers/downloadDocument";
import { downloadsTitle } from "shared/utils/data/infoDownloadDocument";
import { getFileToExport } from "shared/api/services/getFileToExport";
import { convertPaymentAuthorization } from "shared/mappers";
import { convertDataContracts } from "shared/mappers/convertDataContracts";
import axios from "axios";
import { convertUsersProviders } from "shared/mappers/convertUsersProviders";

export const electronicDocuments = createModel<RootModel>()({
  state: {
    content: null,
    totalElements: 0,
    number: 0,
    size: 0,
    contentSize: 0,
    paramsUrl: {},
    url: "",
  } as IElectronicDocuments,
  reducers: {
    addState(state, payload) {
      return {
        userToken: payload.userToken,
        paramsUrl: payload.paramsUrl,
        url: payload.url,
        ...payload.res,
        content: payload.res.content,
      };
    },
    cleanState(state) {
      return {
        ...state,
        content: null,
        totalElements: 0,
        number: 0,
        size: 0,
        contentSize: 0,
        paramsUrl: {},
        url: "",
      };
    },
    getElectronicDoc(state, payload) {
      const updatedContent = state.content
        ? state.content.map((doc) =>
            doc.id === payload.content[0].id ? payload.content[0] : doc,
          )
        : payload.content;

      return {
        ...state,
        content: updatedContent,
      };
    },
  },
  effects: (dispatch) => ({
    async getElectronicDocumentAsync(paramsUrl, state) {
      const response = await apiInstance.get(`${GET_ELECTRONIC_DOCS}/page`, {
        params: { ...paramsUrl, states: "" },
      });
      dispatch.electronicDocuments.getElectronicDoc(response.data);
    },

    async getElectronicDocuments(paramsUrl, state, url) {
      try {
        const response = await apiInstance.get(url, {
          params: { ...paramsUrl },
        });

        const data = url.includes(GET_CONTRACTS_NUMBER)
          ? convertDataContracts(response?.data)
          : convertPaymentAuthorization(response?.data);

        state.electronicDocuments = {
          paramsUrl,
          url,
          ...data,
        };

        dispatch.electronicDocuments.addState({
          paramsUrl,
          url,
          res: data,
        });
      } catch (error) {
        dispatch.electronicDocuments.cleanState();
      }
    },

    async getAllUsersProviders(paramsUrl, state, { url, userToken }) {
      try {
        const response = await axios.get(url, {
          params: { ...paramsUrl },
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        });

        const data = convertUsersProviders(response.data);

        state.electronicDocuments = {
          paramsUrl,
          url: url,
          userToken,
          ...data,
        };
        dispatch.electronicDocuments.addState({
          paramsUrl,
          url: url,
          res: data,
          userToken,
        });
      } catch (error) {
        dispatch.electronicDocuments.cleanState();
      }
    },

    async putPrepareInvoiceAsync(payload: any, state) {
      await apiInstance.put(
        `${GET_ELECTRONIC_DOCS}/${payload.url}`,
        payload.params,
      );
    },

    async putCancelDocument(payload: any, state) {
      await apiInstance.put(`${GET_ELECTRONIC_DOCS}/${payload.url}`, {
        cancelReason: payload.cancelReason,
      });
    },

    async getFileExcelToExport(payload, state) {
      const response = await getFileToExport(payload);
      downloadDocument(
        response,
        downloadsTitle.successDocument,
        payload.text,
        "success",
      );
    },
  }),
});
